define('modules/accounts/companies/list/view',['require','exports','module','views/BaseView','../collection','views/AlertView','./../modalCantCreate/view','app','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView");
  var Companies = require("../collection");
  var AlertView = require("views/AlertView");
  var ModalCompanyView = require("./../modalCantCreate/view");
  var app = require("app");

  var scrollTop = function () {
    $("html,body").scrollTop(0);
  };

  var View = BaseView.extend({
    template: require("ldsh!./template"),
    alertView: null,
    events: {
      "click #createNewAcccount": "createNewAcccount",
      "click #cancelDelete": "closePopover",
      "click #comfirmDelete": "deleteCompany",
    },
    initialize: function () {
      var self = this;
      this.alertView = null;
      if (this.collection) {
        this.listenTo(this.collection, "reset sync request error", function () {
          self.render();
          if (self.alertView) {
            $("#messages-container").append(self.alertView.render().el);
          }
        });
      }
    },
    afterRender: function () {
      BaseView.prototype.afterRender.call(this);
      var self = this;
      _.each(this.collection.models, function (company) {
        self.initPopover(company.get("id"));
      });
    },
    initPopover: function (company_id) {
      $("#popover-signup-" + company_id).popover({
        title: $.i18n.t("ACCOUNTS.COMPANIES.LBL_CONFIRM_DELETE_COMPANY"),
        html: true,
        content:
          '<button  id="comfirmDelete" type="button" data-id="' +
          company_id +
          '" class="btn btn-xs boton-principal">' +
          $.i18n.t("ACCOUNTS.COMPANIES.LBL_DELETE_COMPANY") +
          "</button>" +
          '<a href="javascript: void(0)" id="cancelDelete" data-target="popover-signup-' +
          company_id +
          '" class="btn--ghost cambiarnombre mt12">' +
          $.i18n.t("ACCOUNTS.COMPANIES.LBL_CANCEL") +
          "</a>",
        template:
          '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content center"></div></div>',
      });
    },
    canCreateAcccounts: function () {
      if (this.me.isSuperAdmim()) {
        return true;
      }

      var totalSubAccountCanCreate = 0,
        totalNumSubAccount = 0;
      var services = this.group.get("services");
      _.each(services, function (service) {
        if (service.activeServiceGroup) {
          totalSubAccountCanCreate =
            parseInt(totalSubAccountCanCreate) + parseInt(service.maxCompanies);
          totalNumSubAccount =
            parseInt(totalNumSubAccount) + parseInt(service.numCompanies);
        }
      });
      return totalNumSubAccount < totalSubAccountCanCreate;
    },
    createNewAcccount: function (event) {
      event.preventDefault();
      if (this.canCreateAcccounts()) {
        app.router.navigate(this.getRouteNewCompany(this.options.group.id), {
          trigger: true,
        });
      } else {
        var modalview = new ModalCompanyView({ me: this.me });
        $("#renderModalServices").html(modalview.render().el);
        $("#modalLimitService").modal("show");
      }
    },
    closePopover: function (event) {
      var popover = $(event.currentTarget).attr("data-target");
      $("#" + popover).popover("hide");
    },
    deleteCompany: function (event) {
      var company_id = $(event.currentTarget).attr("data-id");
      var self = this;
      scrollTop();
      _.each(this.collection.models, function (company) {
        if (company.get("id") == company_id) {
          company.destroy({
            success: function (model, response) {
              self.collection.isRequest = false;
              self.render();
              new AlertView({
                el: "#messages-container",
                type: "success",
                msg: "ACCOUNTS.COMPANIES.LBL_DELETE_OK",
              }).render();
            },
            error: function (model, response) {
              self.alertView = new AlertView({
                el: "#messages-container",
                type: "danger",
                msg: "ACCOUNTS.COMPANIES.LBL_ERROR_DELETE_409",
              }).render();
            },
            wait: true,
          });
        }
      });
    },
    serialize: function () {
      return {
        group: this.options.group,
        companies: this.collection,
        groupId: this.options.group.id,
      };
    },
    getRouteNewCompany: function (groupId) {
      var route = "accounts/company/new";
      if (groupId) route += "/group/" + groupId;
      return route;
    },
  });

  module.exports = View;
});

